<style lang="scss" src='./GwExport.scss' scoped></style>
<template src="./GwExport.html"></template>

<script>
import Vue from 'vue';
import JsonCSV from "vue-json-csv";
Vue.component('downloadCsv', JsonCSV)

export default {
  name: "GwExport",
  components: {
    JsonCSV,
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      required: false,
    },
    export: {
      type: Function,
      required: false,
    },
    data:{
      required: false
    },
    csvName:{
      required: false
    },
    advancedOptions:{
      type: Object,
      required: false
    },
    exportCSV: {
      type: Function,
      required: false,
    },
    alternateCSVBtn: {
      required: false,
      default: false,
    },
    showXLSX: {
      required: false,
      default: false,
    },
    exportXLSXFile: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      name:'',
      inputType: "password",
      exportTypes: [
        {
          type: "XLSX",
          icon: "file-spreadsheet"
        },
        {
          type: "CSV",
          icon: "file-spreadsheet"
        },
        {
          type: "PDF",
          icon: "file-richtext"
        },
      ],
    };
  },
  computed: {},

  methods: {
    exportReport(item) {
      this.$refs.exportDropdown.hide(true);
      this.export(item);
    },
    exportAlertnateCSV() {
      this.exportCSV();
    },
    exportXLSX(){
      this.exportXLSXFile();
    }
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.name = (this.csvName) + '.csv';
  },

  beforeDestroy() {},
};
</script>
